import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="hero">
        <div className="text-center">
          <h1 className="mb-4 topheadings">Seamless Voyage, Smart Operations</h1>
          <h4 className="mb-5 topheadings" style={{ opacity: 0.7 }}>
            A multi-tenant, multi-currency ferry booking and operations system.
          </h4>
          <div className="d-flex justify-content-center gap-3 flex-wrap">
            <Link
              to="/company-registration"
              className="btn btn-turquoise"
              style={{ lineHeight: "50px", height: "50px", padding: "0 30px", fontWeight: "bold" }}
            >
              Company Registration
            </Link>
          </div>
        </div>
      </section>

      {/* Features */}
      <section id="features" className="features py-5">
        <div className="container text-center">
          <h2 className="mb-5">Why Choose Our System?</h2>
          <div className="row justify-content-center g-4 mb-5">
            <div className="col-lg-5">
              <img src="/images/feature.png" style={{ width: "100%" }} alt="Feature" />
            </div>
            <div className="col-lg-1" />
            <div className="col-lg-6">
              <div className="row justify-content-center g-4">
                <div className="col-md-6 col-6">
                  <div className="card h-100">
                    <div className="card-body text-center">
                      <img
                        src="/images/f1.png"
                        style={{ marginBottom: "10px" }}
                        alt="Multi-Tenant"
                      />
                      <h4>Multi-Tenant</h4>
                      <p>Independent environment for each company.</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-6">
                  <div className="card h-100 trans">
                    <div className="card-body text-center">
                      <img src="/images/f2.png" alt="Multi-Currency" />
                      <h4>Multi-Currency</h4>
                      <p>Real-time exchange rate conversion.</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-6">
                  <div className="card h-100 trans1">
                    <div className="card-body text-center">
                      <img
                        src="/images/f3.png"
                        style={{ marginBottom: "10px" }}
                        alt="Agent Network"
                      />
                      <h4>Agent Network</h4>
                      <p>Marine, commercial, selling agents hierarchy.</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-6">
                  <div className="card h-100 trans2">
                    <div className="card-body text-center">
                      <img
                        src="/images/f4.png"
                        style={{ marginBottom: "12px" }}
                        alt="Smart Finance"
                      />
                      <h4>Smart Finance</h4>
                      <p>Automated ledgers, commissions, quotas.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* "#" -> /company-site */}
          <Link
            to="/company-site"
            className="btn btn-turquoise"
            style={{ height: "auto", padding: "10px 30px" }}
          >
            See More
          </Link>
        </div>
      </section>

      {/* How It Works */}
      <section id="how" className="how-it-works">
        <div className="container text-center">
          <h2 className="mb-5 topheadings">How the System Works</h2>

          <div className="timeline d-flex flex-wrap justify-content-between align-items-start position-relative mb-5">
            <div className="timeline-step">
              <div className="icon-circle mx-auto mb-3">
                <i className="bi bi-clipboard-data"></i>
              </div>
              <h5>Company creates trips &amp; pricing</h5>
            </div>

            <div className="timeline-step">
              <div className="icon-circle mx-auto mb-3">
                <i className="bi bi-people-fill"></i>
              </div>
              <h5>Agents sell tickets/cargo</h5>
            </div>

            <div className="timeline-step">
              <div className="icon-circle mx-auto mb-3">
                <i className="bi bi-laptop"></i>
              </div>
              <h5>Customers book via web portal</h5>
            </div>

            <div className="timeline-step">
              <div className="icon-circle mx-auto mb-3">
                <i className="bi bi-qr-code-scan"></i>
              </div>
              <h5>Check-in &amp; boarding handled digitally</h5>
            </div>

            <div className="timeline-step">
              <div className="icon-circle mx-auto mb-3">
                <i className="bi bi-cash-coin"></i>
              </div>
              <h5>Finance &amp; ledgers updated automatically</h5>
            </div>
          </div>

          {/* "#" -> /company-site */}
          <Link
            to="/company-site"
            className="btn btn-turquoise"
            style={{ height: "auto", padding: "10px 30px" }}
          >
            See More
          </Link>
        </div>
      </section>

      {/* Access Gateway */}
      <section className="access-section py-5" id="login">
        <div className="container text-center">
          <div className="row align-items-center">
            <div className="col-lg-6 borderr">
              <img src="/images/login.png" style={{ width: "100%" }} alt="Login" />
            </div>

            <div className="col-lg-6">
              <h2 className="mb-5">Access Your Environment</h2>
              {/* Remove action="company-login.html" – SPA routing */}
              <form className="mx-auto" style={{ maxWidth: "80%" }}>
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    placeholder="Enter Company Name"
                  />
                </div>

                {/* Go to Login -> https://company.voyagian.com/company-login */}
                <a href="https://company.voyagian.com/company-login" className="btn btn-primary-navy w-100 mb-3">
                  Go to Login
                </a>

                <div className="d-flex align-items-center my-3">
                  <hr className="flex-grow-1" />
                  <span className="px-2">OR</span>
                  <hr className="flex-grow-1" />
                </div>

                {/* Passenger Login -> https://voyagian.com/prakash-corporate/login */}
                <a href="https://voyagian.com/prakash-corporate/login" className="btn btn-outline-navy w-100">
                  Passenger Login (B2C Portal)
                </a>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Callout Differentiators */}
      <section className="callout">
        <div className="container text-center">
          <div className="row justify-content-center g-4">
            <div className="col-md-4">
              <div className="p-4 bg-white text-dark rounded text-center shadow h-100">
                <img
                  src="/images/1.png"
                  style={{ marginBottom: "10px" }}
                  alt="Secure & Compliant"
                />
                <h4 className="calltitle"> Secure &amp; Compliant</h4>
                <p>Role-based access control, layered ledgers.</p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="p-4 bg-white text-dark rounded text-center shadow h-100">
                <img
                  src="/images/2.png"
                  style={{ marginBottom: "10px" }}
                  alt="Scalable"
                />
                <h4 className="calltitle"> Scalable</h4>
                <p>Unlimited companies, trips, and agents.</p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="p-4 bg-white text-dark rounded text-center shadow h-100">
                <img src="/images/3.png" alt="Responsive" />
                <h4 className="calltitle">Responsive</h4>
                <p>Desktop, tablet, and mobile optimized.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Home;
